export enum DataProviderType {
    DRILLED_WELLBORE_PICKS = "DRILLED_WELLBORE_PICKS",
    DRILLED_WELL_TRAJECTORIES = "DRILLED_WELL_TRAJECTORIES",
    PLANNED_WELL_TRAJECTORIES = "PLANNED_WELL_TRAJECTORIES",
    INTERSECTION_WITH_WELLBORE_EXTENSION_REALIZATION_GRID = "INTERSECTION_WITH_WELLBORE_EXTENSION_REALIZATION_GRID",
    INTERSECTION_SEISMIC = "INTERSECTION_SEISMIC",
    INTERSECTION_REALIZATION_GRID = "INTERSECTION_REALIZATION_GRID",
    FAULT_POLYGONS = "FAULT_POLYGONS",
    REALIZATION_POLYGONS = "REALIZATION_POLYGONS",
    DEPTH_SURFACE = "DEPTH_SURFACE",
    ISOCHORE_SURFACE = "ISOCHORE_SURFACE",
    INITIAL_FLUID_CONTACT_SURFACE = "INITIAL_FLUID_CONTACT_SURFACE",
    SEISMIC_3D_SURFACE = "SEISMIC_3D_SURFACE",
    SEISMIC_4D_SURFACE = "SEISMIC_4D_SURFACE",
    ATTRIBUTE_STATIC_SURFACE = "ATTRIBUTE_STATIC_SURFACE",
    ATTRIBUTE_TIME_STEP_SURFACE = "ATTRIBUTE_TIME_STEP_SURFACE",
    ATTRIBUTE_INTERVAL_SURFACE = "ATTRIBUTE_INTERVAL_SURFACE",
}
